import {
  IonBadge,
    IonButton,
    IonButtons,
    IonContent,
    IonHeader,
    IonIcon,
    IonItem,
    IonItemGroup,
    IonLabel,
    IonList,
    IonModal,
    IonTitle,
    IonToolbar
} from '@ionic/react';
import React, { useEffect, useState } from 'react';
import { personOutline, closeCircle} from 'ionicons/icons';
import { modalController } from '@ionic/core';
import './HistoryModal.css';
import ServerService from '../services/Server';
//import { Environment } from "../data/Environment";

const server = new ServerService();

interface HistoryModalProps {
    id:any;
    isOpen: any;
    onDismiss:any;
}

const HistoryModal: React.FC<HistoryModalProps> = ({id,isOpen,onDismiss}) => {

  const [open, setOpen] = useState(false)
  const [items, setItems] = useState([])

  const fetchItems = () => {
    
    const data = {id:id,lang:""}
    fetch(server.getFullUrl("memo/wf/dtl/list", data),
        server.getRequest()
      ).then(
      response => response.json() // if the response is a JSON object
    ).then(res => {
      if (res.success) {
        console.log("success")
        setItems(res.data)
      } else {
        console.log("!success:"+res.message);
  
        if (res.message.startsWith("|BG_ERR|")) {
          //setErrMsg(res.message.substring("|BG_ERR|".length));
        } else {
          //setErrMsg(res.message);
        }
  
        //setError(true);
      }
    }).catch(
      error => {
        console.log(error) // Handle the error response object
      }
    )
  }

  useEffect(() => {
      if (open !== isOpen) {
        setOpen(isOpen)
        if (isOpen) {
          setItems([])
          fetchItems()
        }
      }
  }, [isOpen])

  return (
    <IonModal
        className="my-custom-class"
        isOpen={open}
        //swipeToClose={true}
        onDidDismiss={() => {
            onDismiss();
        }}
      >
        <IonHeader>
            <IonToolbar>
                <IonButtons slot="end">
                <IonButton onClick={async () => {await modalController.dismiss()}}>
                    <IonIcon slot="icon-only" icon={closeCircle}/>
                </IonButton>
                </IonButtons>
                <IonTitle>{id} : History</IonTitle>
            </IonToolbar>
        </IonHeader>

        <IonContent>
        <IonList>
            {items?.map((item,i) => {
                return (
                  <IonItemGroup>
                    <IonItem key={i*3} lines="none">
                        <IonIcon size="large" icon={personOutline}/>
                        <IonBadge color="light">{item.byDtl}</IonBadge>
                    </IonItem>
                    <IonItem key={i*3+1} lines={item.comment ? "none" : undefined}>
                        <IonBadge color="light">{item.startTime}</IonBadge>&nbsp;
                        <IonBadge color="primary">{item.task}</IonBadge>&nbsp;
                        <IonBadge color="success">{item.statusLabel}</IonBadge>
                    </IonItem>
                    {item.comment ? (
                      <IonItem key={i*3+2}>
                          <IonLabel className="ion-text-wrap">{item.comment}</IonLabel>
                      </IonItem>
                    ) : (
                      ""
                    )}
                  </IonItemGroup>
                )
            })}
        </IonList>
        </IonContent>
    </IonModal>
  )
        
};

export default HistoryModal;
